// Declare variables for various UI elements
let checkoutButton
let subtotalInUI
let carttotalInUI
let discountInUI
let totalInUI
let subtotalPointsInUI
let cartPointsSubtotal
let modalhdCartTotal
let modalhdDiscount
let modalhdTotal
let modalhdPointsSubtotalDiscount
let modalSubtotalInUI
let modalSubtotalPointsInUI
let cartItemsArray = [];

let defaultcheckoutButtonText = 'Checkout'
let defaultConfigs;

function getWebConfigs({ siteName, siteDomainName }: { siteName: string, siteDomainName: string }) {
	defaultConfigs = { siteName, siteDomainName }
}

// Declare a list to keep track of loading operations
let loadingList = []

let previousQuickCartContent

const GA4Items = [];

$(function () {
	checkoutButton = document.querySelector('#btn_cart_checkout')
	subtotalInUI = document.querySelector('#subtotalInUI')
	carttotalInUI = document.querySelector('#carttotalInUI')
	discountInUI = document.querySelector('#discountInUI')
	totalInUI = document.querySelector('#totalInUI')
	subtotalPointsInUI = document.querySelector('#cartPointsSubtotal')
	cartPointsSubtotal = document.querySelector('#cartPointsSubtotal')
	modalhdCartTotal = document.querySelector('#hdCartTotal')
	modalhdDiscount = document.querySelector('#hdDiscount')
	modalhdTotal = document.querySelector('#hdTotal')
	modalhdPointsSubtotalDiscount = document.querySelector('#hdPointsSubtotalDiscount')
	modalSubtotalInUI = document.querySelector('#hdCashSubtotal')
	modalSubtotalPointsInUI = document.querySelector('#hdPointsSubtotal')

	function debounce(func, wait) {
		let timeout;

		return function executedFunction() {
			const context = this;
			const args = arguments;

			const later = function () {
				timeout = null;
				func.apply(context, args);
			};

			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	}

	// Updated handleQtyButtonClick using debounce
	const handleQtyButtonClickDebounce = debounce(function () {

		// Get the index from the data-index attribute
		const index = this.getAttribute('data-index');

		// Determine the operation (increment or decrement) and update the value accordingly
		addLoadingBarToSubtotals();
		const parentElement = this.parentNode as Element;
		parentElement.classList.add('loader-absolute-right');

		const invtId = $(this).data('invtid');
		const basketId = $(this).data('basketid');
		const undoDiv = `undo${index}`;
		const inputElement = document.getElementById(`cartQty${index}`) as HTMLInputElement;
		// Get the value of the input element
		const inputElementValue = inputElement.value;

		if (inputElementValue === "0") {
			const content = $(`.cartitem${index}`).html();
			// Get the content inside the div with the class "cartitem" using jQuery
			const quickCartContent = $(`.quickcartitem${index}`).html();
			// Store the content along with its index in an object
			const cartItem = {
				index: index,
				content: content,
				qty: inputElementValue,
				quickCartContent: quickCartContent
			};
			cartItemsArray.push(cartItem);
		}


		updateProductQuantityInCart(invtId, inputElement, basketId, undoDiv);
		this['oldvalue'] = inputElement.value;
	}, 500);

	const handleQtyButtonClick = function () {

		// Get the operation (increment or decrement) from the data-operation attribute
		const operation = this.getAttribute('data-operation');
		// Get the index from the data-index attribute
		const index = this.getAttribute('data-index');

		// Find the input element with the corresponding index
		const quantityInput = document.getElementById(`cartQty${index}`) as HTMLInputElement;
		let currentValue = parseInt(quantityInput.value, 10) || 0;
		// Determine the operation (increment or decrement) and update the value accordingly
		if (operation === 'increment' && currentValue < 99) {
			quantityInput.setAttribute("value", (currentValue + 1).toString());
		} else if (operation === 'decrement' && currentValue > 0) {
			quantityInput.setAttribute("value", (currentValue - 1).toString());
		}

	};

	const handleQtyButtonUpdate = function () {
		addLoadingBarToSubtotals();
		// Add loader class to parent element
		(this.parentNode as Element).classList.add('loader-absolute-right');

		// Retrieve index and undoDiv values
		const index: number = $(this).data('index');
		const undoDiv: string = `undo${index}`;

		// Create a debounce function to delay execution
		const delayDebounceFn = setTimeout(() => {
			// Retrieve necessary data attributes
			const invtId: string = $(this).data('invtid');
			const basketId: string = $(this).data('basketid');

			// Update product quantity in cart
			updateProductQuantityInCart(invtId, this as HTMLInputElement, basketId, undoDiv);

			// Store the current value as old value
			this['oldvalue'] = (this as HTMLInputElement).value;
		}, 2000);

		// Return a cleanup function to clear the timeout
		return () => clearTimeout(delayDebounceFn);

	}

	// Attach the function to the event using event delegation
	$(document).on('click', '.qtyBtn', handleQtyButtonClick);
	$(document).on('click', '.qtyBtn', handleQtyButtonClickDebounce);
	$(document).on('input', '.quantity-input', handleQtyButtonUpdate);

	function handleDeleteButtonClick(e) {
		e.preventDefault();
		const invtId = $(this).data('invtid');
		const basketId = $(this).data('basketid');
		const index = $(this).data('index');
		const itemId = $(this).data('itemid');
		const inputElement = document.getElementById(`cartQty${index}`) as HTMLInputElement;
		const inputElementValue = inputElement.value;
		// Get the content inside the div with the class "cartitem" using jQuery
		const content = $(`.cartitem${index}`).html();
		const quickCartContent = $(`.quickcartitem${index}`).html();
		// Store the content along with its index in an object
		const cartItem = {
			index: index,
			content: content,
			qty: inputElementValue,
			quickCartContent: quickCartContent
		};
		deleteProductInCart(invtId, basketId);
		const undoDiv = `undo${index}`;
		cartItemsArray.push(cartItem);
		let cartItems = retrieveItemIDs()
		removeElementByItemId(cartItems, itemId);
		CommonUtils.showElement(undoDiv);
	}

	// Attach the function to the event using event delegation
	$(document).on('click', '.delete-product', handleDeleteButtonClick);

	function handleUndoButtonClick(index, basketId, productID, productExtensionGroups, productSelectedExtensions) {
		const ajaxObj = new XMLHttpRequest();
		const undoDiv = `undo${index}`;
		// Get the element by its ID
		const undoDivElement = document.getElementById(undoDiv);

		const dataAttributes = {
			'data-affiliation': '<%=Affiliation%>',
			'data-itembrand': '<%=ItemBrand%>',
			'data-quantity': '<%=Quantity%>',
			'data-name': '<%=Name%>',
			'data-index': index,
			'data-categoryname': '<%=CategoryName%>',
			'data-categoryid': '<%=CategoryId%>',
			'data-price': '<%=Price%>',
			'data-discount': '<%=Discount%>',
			'data-extensiongroups': productExtensionGroups,
			'data-selectedextensions': productSelectedExtensions,
			'data-variant': '<%=System.Net.WebUtility.HtmlEncode(String.Join(";", Variant))%>',
			'data-basketid': basketId,
			'data-invtid': '<%=dsBasket.Tables[1].Rows[k]["InvtID"].ToString().Trim()%>',
			'data-itemid': '<%=dsBasket.Tables[1].Rows[k]["ItemID"].ToString().Trim()%>'
		};
		addControls();
		// Add a loading bar to the subtotals
		addLoadingBarToSubtotals();
		undoDivElement.classList.add('loader-absolute-right');
		// Add the product ID to the loading list
		loadingList.push(productID);

		// Disable the checkout button and the quantity span
		checkoutButton.classList.add('disabled');
		checkoutButton.classList.add('loader-light');
		checkoutButton.innerText = '';
		checkoutButton.disabled = true;

		// Remove the product ID from the loading list
		const indexList = loadingList.indexOf(productID);
		if (indexList !== -1) {
			loadingList.splice(indexList, 1);
		}

		// Split the values based on semicolon
		const extensionGroupsArray = productExtensionGroups.split(';').filter(Boolean);
		const selectedExtensionsArray = productSelectedExtensions.split(';').filter(Boolean);

		// Initialize paramExtensions
		let paramExtensions = '';
		let deletedInvtId = productID;

		// Iterate through the arrays and create paramExtensions
		for (let i = 0; i < extensionGroupsArray.length; i++) {
			paramExtensions += `&${productID}${extensionGroupsArray[i]}=${selectedExtensionsArray[i]}`;
			deletedInvtId += `${selectedExtensionsArray[i]}`
		}

		const cartItemObj = cartItemsArray.find(item => item.index == index);
		let cartItemQty = cartItemObj ? cartItemObj.qty.trim() : "1";
		if (cartItemQty === "0") cartItemQty = "1";

		const ajaxParams = `&posting=TRUE&actionType=CARTADD&productID=${encodeURIComponent(productID)}&quantity=${encodeURIComponent(cartItemQty)}&productIDExtensionGroups=${encodeURIComponent(productExtensionGroups)}${paramExtensions}`;

		const ajaxURL = 'ajax/cart.aspx';
		let ajaxResults = '';

		ajaxObj.open('POST', ajaxURL, true);
		ajaxObj.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
		ajaxObj.send(ajaxParams);

		ajaxObj.onreadystatechange = async function () {
			if (ajaxObj.readyState === 4) {
				ajaxResults = ajaxObj.responseText + '';
				if (ajaxResults !== '') {

					let totalBasketRows = Number(CommonUtils.getXMLDataTableRowCount('dsBasket', 1, ajaxResults));
					let dsBasketDeletedRow;
					for (let k = 0; k < totalBasketRows; k++) {
						if (CommonUtils.getXMLDataFieldValue('dsBasket', 1, k, 'invtid', ajaxResults) === deletedInvtId || CommonUtils.getXMLDataFieldValue('dsBasket', 1, k, 'alternateid', ajaxResults) === deletedInvtId) {
							dsBasketDeletedRow = k;
							break;
						}
					}
					const currentBasketID = CommonUtils.getXMLDataFieldValue('dsBasket', 1, dsBasketDeletedRow, 'basketID', ajaxResults);
					const itemContentObj = cartItemsArray.find(item => item.index == index);
					let itemContent = itemContentObj ? itemContentObj.content : null;
					let quickItemContent = itemContentObj ? itemContentObj.quickCartContent : null;

					let totalQuantity = 0;
					for (let i = 0; i < totalBasketRows; i++) {
						totalQuantity += parseInt(CommonUtils.getXMLDataFieldValue('dsBasket', 1, i, 'qtyOrd', ajaxResults))
					}
					// Replace occurrences of basketId with currentBasketID
					let escapedBasketId = escapeRegExp(basketId);
					let regex = new RegExp(escapedBasketId, 'g');
					itemContent = itemContent.replace(regex, currentBasketID);
					itemContent = itemContent.replace(/loader-absolute-right/g, '');
					quickItemContent = quickItemContent.replace(regex, currentBasketID);
					delete GA4Items[basketId];
					const tempElement = document.createElement('div');
					tempElement.innerHTML = itemContent;

					const qtyInput = tempElement.querySelector(`#cartQty${index}`);
					if (qtyInput instanceof HTMLInputElement) {
						qtyInput.setAttribute("value", cartItemQty);
					}

					itemContent = tempElement.innerHTML;
					CommonUtils.hideElement(undoDiv);
					undoDivElement.classList.remove('loader-absolute-right');
					const cartItemsContainer = document.querySelector(`.cartitem${index}`);
					cartItemsContainer.innerHTML = itemContent;
					if (totalQuantity > 0) {
						const quickCartItemContainer = document.querySelector(`.quickcartitem${index}`)
						quickCartItemContainer.innerHTML = quickItemContent;
						CommonUtils.showElement('#DIVcartSumItemsList');
						CommonUtils.showElement('#DIVcartbtns');
						CommonUtils.hideElement('#DIVNoItem');
					} else {
						CommonUtils.hideElement('#DIVcartSumItemsList');
						CommonUtils.hideElement('#DIVcartbtns');
						CommonUtils.showElement('#DIVNoItem');
					}

					cartItemsArray = cartItemsArray.filter(item => item.index !== index);

					// Update the total quantity in the UI
					const bubbleCnt = document.querySelector('#bubble-cnt');
					if (bubbleCnt) bubbleCnt.innerHTML = totalQuantity.toString();

					// Get the subtotal and subtotal points from the JSON data
					const subtotal = CommonUtils.getXMLDataFieldValue('dsBasket', 0, 0, 'CuryTotMerch', ajaxResults);
					const subtotalPoints = CommonUtils.getXMLDataFieldValue('dsBasket', 0, 0, 'User6', ajaxResults);

					if (isBMSMActive) {
						updateBMSMsubTotals(Number(parseFloat(subtotal).toFixed(2)))
					}

					// Enable the checkout button
					checkoutButton.disabled = false;
					checkoutButton.innerText = defaultcheckoutButtonText;
					checkoutButton.classList.remove('loader-light');
					checkoutButton.classList.remove('disabled');

					// Update the subtotal and subtotal points in the main UI		
					subtotalInUI.classList.remove('loader-dark-small');
					subtotalInUI.innerHTML = `$${parseFloat(subtotal).toFixed(2)}`;
					carttotalInUI.classList.remove('loader-dark-small');
					carttotalInUI.innerHTML = `$${parseFloat(subtotal).toFixed(2)}`;
					subtotalPointsInUI.classList.remove('loader-dark-small');
					subtotalPointsInUI.innerHTML = `${CommonUtils.formatPoints(subtotalPoints)} Points`;
					cartPointsSubtotal.classList.remove('loader-dark-small');
					cartPointsSubtotal.innerHTML = `${CommonUtils.formatPoints(subtotalPoints)} Points`;

					// // Update the subtotal and subtotal points in the modal UI
					modalhdCartTotal.classList.remove('loader-dark-small');
					modalhdCartTotal.innerHTML = `$${parseFloat(subtotal).toFixed(2)}`;
					modalhdPointsSubtotalDiscount.classList.remove('loader-dark-small');
					modalhdPointsSubtotalDiscount.innerHTML = `${CommonUtils.formatPoints(subtotalPoints)} Points`;
					modalSubtotalInUI.classList.remove('loader-dark-small');
					modalSubtotalInUI.innerHTML = `$${parseFloat(subtotal).toFixed(2)}`;
					modalSubtotalPointsInUI.classList.remove('loader-dark-small');
					modalSubtotalPointsInUI.innerHTML = `${CommonUtils.formatPoints(subtotalPoints)} Points`;

					let item_variant = CommonUtils.getXMLDataFieldValue('dsBasketExtensions', 0, dsBasketDeletedRow, 'Descr', ajaxResults);

					GA4Items[currentBasketID] = {
						item_id: CommonUtils.getXMLDataFieldValue('dsBasket', 1, dsBasketDeletedRow, 'itemId', ajaxResults),
						item_name: CommonUtils.getXMLDataFieldValue('dsBasket', 1, dsBasketDeletedRow, 'descr', ajaxResults),
						affiliation: defaultConfigs.siteName,
						price: CommonUtils.getXMLDataFieldValue('dsBasket', 1, dsBasketDeletedRow, 'curylistprice', ajaxResults),
						discount: CommonUtils.getXMLDataFieldValue('dsBasket', 1, dsBasketDeletedRow, 'discacct', ajaxResults) || 0,
						subscription: CommonUtils.getXMLDataFieldValue('dsBasket', 1, dsBasketDeletedRow, 'itemId', ajaxResults).includes('-SUB') ? 'yes' : 'no',
						item_brand: defaultConfigs.siteDomainName,
						item_category: CommonUtils.getXMLDataFieldValue('dsBasket', 1, dsBasketDeletedRow, 'parentcategoryid', ajaxResults),
						quantity: CommonUtils.getXMLDataFieldValue('dsBasket', 1, dsBasketDeletedRow, 'qtyord', ajaxResults),
						index: index,
						item_list_id: CommonUtils.getXMLDataFieldValue('dsBasket', 1, dsBasketDeletedRow, 'categoryid', ajaxResults) || 'N/A',
						item_list_name: CommonUtils.getXMLDataFieldValue('dsBasket', 1, dsBasketDeletedRow, 'categoryname', ajaxResults) || 'N/A',
					}
					if (item_variant) {
						GA4Items[currentBasketID] = { ...GA4Items[currentBasketID], item_variant: item_variant }
					}


				}

			}
		}
	}

	// Attach the function to the event using event delegation
	$(document).on('click', '.undo-button', async function () {
		const index = $(this).data('index');
		const basketId = $(this).data('basketid');
		const productID = $(this).data('itemid');
		const productExtensionGroups = $(this).data('extensiongroups');
		const productSelectedExtensions = $(this).data('selectedextensions');

		handleUndoButtonClick(index, basketId, productID, productExtensionGroups, productSelectedExtensions);
	});
})


// Function to escape special characters in a string for RegExp
function escapeRegExp(string) {
	return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function formatPrice(price) {
	// Remove non-digit characters
	let formattedPrice = price.replace(/\D/g, '')

	// Add a decimal point before the last two digits
	formattedPrice = formattedPrice.replace(/(\d)(\d{2})$/, '$1.$2')

	// Add commas as thousand separators
	formattedPrice = formattedPrice.replace(/(?=(\d{3})+(\D))\B/g, ',')

	return formattedPrice
}

/**
 * Sanitize a string and parse it into a JSON object.
 * @param {string} data - The string to sanitize and parse.
 * @return {Object} The parsed JSON object.
 */
function sanitizeToJson(data: string) {
	// Remove all newline characters from the string
	data = data.replace(/\n/g, '')

	// Remove all characters from the start of the string up to the first '{'
	data = data.replace(/^[^{]*/g, '')

	// Parse the sanitized string into a JSON object
	const jsonData = JSON.parse(data)

	return jsonData
}

/**
 * Add a loading bar to the subtotal elements in the UI.
 */
function addLoadingBarToSubtotals() {
	// Define the HTML for the loading bar
	const loadingHtml = '<img src="images/misc/loading.gif" alt="loading" width="15">'

	// Add the loading bar to the subtotal elements in the main UI
	subtotalInUI.innerHTML = ''
	subtotalInUI.classList.add('loader-dark-small')
	carttotalInUI.innerHTML = ''
	carttotalInUI.classList.add('loader-dark-small')
	discountInUI.innerHTML = ''
	discountInUI.classList.add('loader-dark-small')
	totalInUI.innerHTML = ''
	totalInUI.classList.add('loader-dark-small')
	subtotalPointsInUI.innerHTML = ''
	subtotalPointsInUI.classList.add('loader-dark-small')
	cartPointsSubtotal.innerHTML = ''
	cartPointsSubtotal.classList.add('loader-dark-small')

	// Add the loading bar to the subtotal elements in the modal UI
	modalhdCartTotal.innerHTML = ''
	modalhdCartTotal.classList.add('loader-dark-small')
	modalhdPointsSubtotalDiscount.innerHTML = ''
	modalhdPointsSubtotalDiscount.classList.add('loader-dark-small')
	modalSubtotalInUI.innerHTML = ''
	modalSubtotalInUI.classList.add('loader-dark-small')
	modalSubtotalPointsInUI.innerHTML = ''
	modalSubtotalPointsInUI.classList.add('loader-dark-small')
}

/**
 * Update the cart UI with the given data.
 * @param {string} data - The data to update the cart UI with.
 */
function updateCartUI(data: string) {
	// If there are still items loading, don't update the UI
	if (loadingList.length > 0) return;

	// Sanitize the data and parse it into a JSON object
	const jsonData = sanitizeToJson(data);

	//Update BMSM subtotals
	if (isBMSMActive) {
		updateBMSMsubTotals(jsonData.Table[0].CuryTotMerch)
	}

	// Get the subtotal and subtotal points from the JSON data
	const subtotal = jsonData.Table[0].CuryTotMerch.toFixed(2).toString();
	const subtotalPoints = jsonData.Table[0].User6;

	// Update the subtotal and subtotal points in the main UI
	subtotalInUI.classList.remove('loader-dark-small');
	subtotalInUI.innerHTML = `$${formatPrice(subtotal)}`;
	carttotalInUI.classList.remove('loader-dark-small');
	carttotalInUI.innerHTML = `$${formatPrice(subtotal)}`;
	subtotalPointsInUI.classList.remove('loader-dark-small');
	subtotalPointsInUI.innerHTML = `${CommonUtils.formatPoints(subtotalPoints)} Points`;
	cartPointsSubtotal.classList.remove('loader-dark-small');
	cartPointsSubtotal.innerHTML = `${CommonUtils.formatPoints(subtotalPoints)} Points`;

	// Update the subtotal and subtotal points in the modal UI
	modalhdCartTotal.classList.remove('loader-dark-small');
	modalhdCartTotal.innerHTML = `$${formatPrice(subtotal)}`;
	modalSubtotalInUI.classList.remove('loader-dark-small');
	modalSubtotalInUI.innerHTML = `$${formatPrice(subtotal)}`;
	modalhdPointsSubtotalDiscount.classList.remove('loader-dark-small');
	modalhdPointsSubtotalDiscount.innerHTML = `${CommonUtils.formatPoints(subtotalPoints)} Points`;
	modalSubtotalPointsInUI.classList.remove('loader-dark-small');
	modalSubtotalPointsInUI.innerHTML = `${CommonUtils.formatPoints(subtotalPoints)} Points`;

	// Calculate the total quantity of items in the cart
	let totalQuantity = 0;
	const productQuantities: NodeListOf<HTMLInputElement> = document.querySelectorAll('[id*=\'cartQty\']');
	productQuantities.forEach(productQuantity => {
		totalQuantity += parseInt(productQuantity.value) || 0;
	});

	// Update the total quantity in the UI
	const bubbleCnt = document.querySelector('#bubble-cnt');
	if (bubbleCnt) bubbleCnt.innerHTML = totalQuantity.toString();

	if (totalQuantity === 0) {
		CommonUtils.hideElement('#DIVcartSumItemsList');
		CommonUtils.hideElement('#DIVcartbtns');
		CommonUtils.showElement('#DIVNoItem');
	} else {
		CommonUtils.showElement('#DIVcartSumItemsList');
		CommonUtils.showElement('#DIVcartbtns');
		CommonUtils.hideElement('#DIVNoItem');
	}
	// Enable the checkout button
	checkoutButton.disabled = false;
	checkoutButton.innerText = defaultcheckoutButtonText;
	checkoutButton.classList.remove('loader-light');
	checkoutButton.classList.remove('disabled');
}

function updateBMSMsubTotals(subtotal: number) {
	//Update BMSM subtotals
	let promoTiersLenght = promoPropsObj.promoTiers.length
	if (subtotal < promoPropsObj.promoTiers[0].minTotal) {
		promoPropsObj.discount = 0;
	} else if (subtotal > promoPropsObj.promoTiers[promoTiersLenght - 1].minTotal) {
		promoPropsObj.discount = promoPropsObj.promoTiers[promoTiersLenght - 1].dollarOff;
	} else {
		for (let i = 0; i < promoTiersLenght - 1; i++) {
			if ((subtotal > promoPropsObj.promoTiers[i].minTotal) && (subtotal < promoPropsObj.promoTiers[i + 1].minTotal)) {
				promoPropsObj.discount = promoPropsObj.promoTiers[i].dollarOff;
			}
		}
	}
	if (promoPropsObj.discount > 0) {
		$('#cartULNoDiscount').hide()
		$('#cartULDiscount').show()
		$('#hdULNoDiscount').hide()
		$('#hdULDiscount').show()
		const subtotalContaniner = document.querySelector('#liSubtotalInUI')
		if (subtotalContaniner) {
			subtotalContaniner.firstElementChild.innerHTML = `<span>Cart Total: &nbsp;</span>`
		}
		discountInUI.classList.remove('loader-dark-small');
		discountInUI.innerHTML = `-$${formatPrice((promoPropsObj.discount).toFixed(2).toString())}`;
		totalInUI.classList.remove('loader-dark-small');
		totalInUI.innerHTML = `$${formatPrice((subtotal - promoPropsObj.discount).toFixed(2).toString())}`;
		modalhdDiscount.classList.remove('loader-dark-small');
		modalhdDiscount.innerHTML = `-$${formatPrice((promoPropsObj.discount).toFixed(2).toString())}`;
		modalhdTotal.classList.remove('loader-dark-small');
		modalhdTotal.innerHTML = `$${formatPrice((subtotal - promoPropsObj.discount).toFixed(2).toString())}`;
	} else {
		const subtotalContaniner = document.querySelector('#liSubtotalInUI')
		if (subtotalContaniner) {
			subtotalContaniner.firstElementChild.innerHTML = `<span>Subtotal: &nbsp;</span>`
		}
		$('#cartULDiscount').hide()
		$('#cartULNoDiscount').show()
		$('#hdULDiscount').hide()
		$('#hdULNoDiscount').show()
	}
}

/**
 * Remove all whitespace characters in a string.
 * @param {string} text - The string to remove whitespace from.
 * @return {string} The string with all whitespace removed.
 */
function removeEmptySpaceInString(text: string) {
	// If the text is falsy (e.g., null, undefined, empty string), return it as is
	if (!text) return text

	// Use a regular expression to replace all whitespace characters with nothing
	const noWhitespaceText = text.replace(/\s/g, '')

	return noWhitespaceText
}

/**
 * Update the UI for a specific cart item with the given data.
 * @param {string} basketID - The ID of the product to update the UI for.
 * @param {string} data - The data to update the cart item UI with.
 */
function updateCartItemUI(basketID: string, data: string, qtyIndex: string) {
	// Select the cart item elements in the main UI and the modal UI
	const cartItem = document.querySelector(`#cart-item-${basketID}`)
	const modalCartItem = document.querySelector(`#modal-cart-item-${basketID}`)

	// Sanitize the data and parse it into a JSON object
	const jsonData = sanitizeToJson(data)

	// Loop through each product in the JSON data
	jsonData.Table1.forEach((product) => {
		// If the product ID in the JSON data doesn't match the given product ID, skip this iteration
		if (removeEmptySpaceInString(product.basketid) !== basketID) return
		// Update the product quantity price in the main UI
		cartItem.querySelector(`#product-quantity-price${qtyIndex}`).innerHTML = `$${formatPrice(product.curytotord.toFixed(2).toString())}`
		cartItem.querySelector('#product-quantity-price-in-points').innerHTML = `${CommonUtils.formatPoints(product.user6)} Points`

		// Update the product quantity in the modal UI
		modalCartItem.querySelector('#cart-modal-product-quantity').innerHTML = product.quantity
		document.querySelector(`#cart-item-${basketID} .delete-product`).setAttribute('data-quantity', product.quantity.toString())

	})

}

/**
 * Delete the UI elements for a specific cart item.
 * @param {string} basketID - The ID of the product to delete the UI elements for.
 */
function deleteCartItemUI(basketID: string) {
	// Select the cart item elements in the main UI and the modal UI
	const cartItem: HTMLElement = document.querySelector(`#cart-item-${basketID}`)
	const modalCartItem: HTMLElement = document.querySelector(`#modal-cart-item-${basketID}`)

	// If the cart item element exists in the main UI, remove it
	if (cartItem) {
		cartItem.parentNode.removeChild(cartItem)
	}

	// If the cart item element exists in the modal UI, remove it
	if (modalCartItem) {
		modalCartItem.parentNode.removeChild(modalCartItem)
	}
}

/**
 * Empty the cart by removing the cart items from the UI and displaying a message that the cart is empty.
 */
function emptyCart() {
	// Select the cart item elements in the main UI
	const cartItemsHeader = document.querySelector('#cart-items-header')
	const cartItemsContainer = document.querySelector('#cart-items-container')
	const cartItemsCheckoutContainer = document.querySelector('#cart-items-checkout-container')

	// Select the cart item elements in the modal UI
	const modalCartContainer = document.querySelector('#div_drop-shopcart')
	const modalCartQuantityCountSum = document.querySelector('#cartSumQty')

	// If the cart item elements exist in the main UI, remove them
	/* 	if (cartItemsHeader) {
			cartItemsHeader.parentNode.removeChild(cartItemsHeader)
		}
		if (cartItemsCheckoutContainer) {
			cartItemsCheckoutContainer.parentNode.removeChild(cartItemsCheckoutContainer)
		}
		if (modalCartQuantityCountSum) {
			modalCartQuantityCountSum.parentNode.removeChild(modalCartQuantityCountSum)
		} */
	// Define the HTML for the empty cart message
	const htmlString = '<div class="shopping-cart empty-cart"><ul><li><p>You have no items in your bag.</p><p class="button left"><a class="btn-main" href="index.aspx" onclick="this.blur();"><span>Continue Shopping</span></a></p></li></ul></div>'

	//Hide DIVcartSumItemsList element and show DIVNoItem
	CommonUtils.hideElement('#DIVcartSumItemsList');
	CommonUtils.hideElement('#DIVcartbtns');
	CommonUtils.showElement('#DIVNoItem');
}

function removeControls() {
	CommonUtils.hideElement('cart-items-checkout-container');
}

function addControls() {
	CommonUtils.showElement('cart-items-checkout-container');
}

/**
 * Update the quantity of a product in the cart.
 * @param {string} productID - The ID of the product to update.
 * @param {HTMLElement} quantityInput - The input element for the product quantity.
 * @param {string} basketID - The ID of the basket that contains the product.
 */
async function updateProductQuantityInCart(productID: string, quantityInput: HTMLInputElement, basketID: string, undoDiv: string) {
	let deleteItem = false;
	const parentElement = quantityInput.parentNode;
	// Retrieve the quantity value from the input element
	const quantityValue = parseInt(quantityInput.value);
	const qtyIndex = quantityInput.getAttribute('data-index')!;

	// If the quantity is 0 or less, confirm with the user if they want to remove the item
	if (quantityValue <= 0) {
		deleteItem = true;
		CommonUtils.showElement(undoDiv);
	}

	// If the quantity is more than 99, alert the user and revert the quantity
	if (quantityValue > 99) {
		alert('Value must be less than or equal to 99.');
		quantityInput.setAttribute("value", quantityInput['oldvalue']);
		quantityInput.value = quantityInput['oldvalue'];
		quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
		return;
	}

	// If the quantity is a float, alert the user and revert the quantity
	if (!Number.isInteger(quantityValue)) {
		quantityInput.setAttribute("value", Math.round(quantityValue).toString());
		return;
	}

	// Add a loading bar to the subtotals
	addLoadingBarToSubtotals();

	// Add the product ID to the loading list
	loadingList.push(productID);

	// Add a loading image next to the quantity input

	if (parentElement instanceof Element) {
		parentElement.classList.add('loader-absolute-right');
	}

	// Disable the checkout button and the quantity input
	checkoutButton.classList.add('disabled');
	checkoutButton.classList.add('loader-light');
	checkoutButton.innerText = '';
	checkoutButton.disabled = true;
	quantityInput.disabled = true; // Disable the input

	// Define the URL and parameters for the AJAX request
	const ajaxCartUrl = '/ajax/newCart.aspx';
	const params = `&actionType=CARTUPDATE&basketId=${basketID}&productID=${productID}&quantity=${quantityValue}&posting=TRUE`;
	// Send the AJAX request
	const request = await $.ajax({
		url: ajaxCartUrl,
		type: 'POST',
		cache: false,
		data: params,
		async: true
	});

	// Remove the product ID from the loading list
	const index = loadingList.indexOf(productID);
	if (index !== -1) {
		loadingList.splice(index, 1);
	}

	// If the item was deleted, update the UI accordingly
	let itemIndex = cartItemsObj.findIndex((item) => item.invtID === productID);
	if (deleteItem) {
		deleteCartItemUI(basketID);
		const jsonData = sanitizeToJson(request);
		if (jsonData.Table1.length <= 0) {
			//emptyCart();
			removeControls();
		}
		cartItemsObj.slice(itemIndex, 1);
	} else {
		// If the item was not deleted, update the cart item UI and enable the quantity input
		updateCartItemUI(basketID, request, qtyIndex);
		quantityInput.disabled = false; // Enable the input
		cartItemsObj[itemIndex].quantity = Number(quantityInput.value);
	}

	// Remove the loading image
	if (parentElement instanceof Element) {
		parentElement.classList.remove('loader-absolute-right');
	}

	// Update the cart UI
	updateCartUI(request);

	// Update Sales Force tracking cart
	sfTrackCart(sanitizeToJson(request));

}


function sfTrackCart(cartData) {
	const cart = cartData.Table1
	const parsedCart = cart.map((item) => ({
		item: item.itemid.trim(),
		quantity: item.qtyord,
		price: item.curylistprice.toFixed(2).toString(),
		sale_price: (item.curylistprice > item.curyslsprice) ? item.curyslsprice.toString() : undefined,
		unique_id: (item.alternateid.trim() || item.invtid.trim())
	}))

	SalesforceAbandonedCartUtils.cartOrOrderData = parsedCart
	SalesforceAbandonedCartUtils.trackCart()
}

/**
 * Delete a product from the cart.
 * @param {string} productID - The ID of the product to delete.
 * @param {string} basketID - The ID of the basket that contains the product.
 */
async function deleteProductInCart(productID, basketID) {
	// Add a loading bar to the subtotals
	addLoadingBarToSubtotals()

	const deletedItemGA4 = GA4Items[basketID]
	if (!deletedItemGA4) {
		return
	};
	const deleteInfo = document.querySelector(`#cart-item-${basketID} .delete-product`)

	// remove the delete button with a loader
	const deleteButton = document.querySelector(`#cart-item-${basketID} .Update`)
	deleteButton.innerHTML = '<span class="loader-absolute-right"></span>'

	// Disable the checkout button
	checkoutButton.classList.add('disabled')
	checkoutButton.classList.add('loader-light')
	checkoutButton.innerText = ''
	checkoutButton.disabled = true

	// Define the URL and parameters for the AJAX request
	const ajaxCartUrl = '/ajax/newCart.aspx'
	let params = `&actionType=CARTDELETE&basketId=${basketID}&productID=${productID}&posting=TRUE`

	// Send the AJAX request
	const request = await $.ajax({
		url: ajaxCartUrl,
		type: 'POST',
		cache: false,
		data: params,
		async: true
	})

	dataLayer.push({ ecommerce: null })  // Clear the previous ecommerce object.
	dataLayer.push({
		'event': 'remove_from_cart',
		'ecommerce': {
			'currency': 'USD',
			'value': Number((deletedItemGA4.price * deletedItemGA4.quantity).toFixed(2)),
			'items': deletedItemGA4
		},
		'event_value': Number((deletedItemGA4.price * deletedItemGA4.quantity).toFixed(2))
	})

	// Delete the cart item UI for the product
	deleteCartItemUI(basketID)

	// Update the cart UI with the response from the AJAX request
	updateCartUI(request)

	// Sanitize the response and parse it into a JSON object
	const jsonData = sanitizeToJson(request)

	// If the cart only has GWP product left, remove it
	if (jsonData.Table1.length === 1 && jsonData.Table1[0].itemid.toLowerCase().includes('gwp')) {
		deleteProductInCart(jsonData.Table1[0].itemid, jsonData.Table1[0].basketid)
	}

	// If there are no more items in the cart, empty the cart
	if (jsonData.Table1.length <= 0) {
		//emptyCart()
		removeControls();
	}

	// Update Sales Force tracking cart
	sfTrackCart(sanitizeToJson(request))
}

/**
 * Empty the entire cart.
 * This function will prompt the user for confirmation before emptying the cart.
 * If the user confirms, it will set the 'actionType' input's value to 'CARTEMPTY' and submit the 'OCForm1' form.
 */
function doEmptyCart() {
	// Prompt the user for confirmation
	const userConfirmed = confirm('Warning: This will empty your entire cart!\n')

	// If the user confirmed, empty the cart
	if (userConfirmed) {
		// Get the 'actionType' input element
		const actionTypeInput = document.getElementById('actionType') as HTMLInputElement

		// Set the 'actionType' input's value to 'CARTEMPTY'
		actionTypeInput.value = 'CARTEMPTY'

		// Get the 'OCForm1' form element
		const form = document.getElementById('OCForm1') as HTMLFormElement

		// Submit the 'OCForm1' form
		form.submit()
	}
}

/**
 * Proceed to checkout.
 * This function will set the 'actionType' input's value to its current value plus ',CARTCHECKOUT' and submit the 'OCForm1' form.
 * This effectively signals that the user wants to proceed to checkout.
 */
function checkout() {
	// Get the 'actionType' input element
	const actionTypeInput = document.getElementById('actionType') as HTMLInputElement

	// Append ',CARTCHECKOUT' to the 'actionType' input's value
	actionTypeInput.value += ',CARTCHECKOUT'

	// Get the 'OCForm1' form element
	const form = document.getElementById('OCForm1') as HTMLFormElement

	// Submit the 'OCForm1' form
	form.submit()
}

// Define a type for cart item
type CartItem = {
	element: HTMLElement;
	itemID: string;
};

function retrieveItemIDs(): CartItem[] {
	// Select all elements with class name 'cart-item'
	const cartItems = document.querySelectorAll('.cart-item');

	// Array to store cart items with element and itemID
	const itemIDs: CartItem[] = [];

	// Loop through each cart-item element
	cartItems.forEach((cartItem) => {
		// Retrieve the value of data-itemid attribute
		const itemID = cartItem.getAttribute('data-itemid');

		// Check if itemID exists and is not empty
		if (itemID) {
			// Store cart item as an object containing element and itemID
			itemIDs.push({ element: cartItem as HTMLElement, itemID });
		}
	});

	// Check if any itemID contains the substring '-SUB'
	const hasSubItem = itemIDs.some((item) => item.itemID.includes('-SUB'));

	// Show or hide error element based on the presence of '-SUB'
	if (hasSubItem) {
		CommonUtils.showElement("cartPointsSubError");
		CommonUtils.showElement("quickcart-points-has-subs");
	} else {
		CommonUtils.hideElement("cartPointsSubError");
		CommonUtils.hideElement("quickcart-points-has-subs");
	}

	// Return the array of CartItem objects
	return itemIDs;
}

function removeElementByItemId(itemIDs: CartItem[], itemIdToRemove: string): void {
	// Find index of item to remove
	const indexToRemove = itemIDs.findIndex((item) => item.itemID === itemIdToRemove);

	// If item found, remove it from the itemIDs array
	if (indexToRemove !== -1) {
		// Remove the element from the DOM
		const elementToRemove = itemIDs[indexToRemove].element;
		//elementToRemove.parentNode?.removeChild(elementToRemove);

		// Remove the item from the itemIDs array
		itemIDs.splice(indexToRemove, 1);

		// After removal, check again for '-SUB' and update error element visibility
		const hasSubItem = itemIDs.some((item) => item.itemID.includes('-SUB'));
		if (hasSubItem) {
			CommonUtils.showElement("cartPointsSubError");
			CommonUtils.showElement("quickcart-points-has-subs");
		} else {
			CommonUtils.hideElement("cartPointsSubError");
			CommonUtils.hideElement("quickcart-points-has-subs");
		}
	}
}